export const SAVE_IMPORT_EXPORT_WIZARD_SUCCESS = 'SAVE_IMPORT_EXPORT_WIZARD_SUCCESS';
export type SAVE_IMPORT_EXPORT_WIZARD_SUCCESS = typeof SAVE_IMPORT_EXPORT_WIZARD_SUCCESS;

export interface SaveImportExportWizardSuccess {
    type: SAVE_IMPORT_EXPORT_WIZARD_SUCCESS;
}

export function saveImportExportWizardSuccessAction(): SaveImportExportWizardSuccess {
    return {
        type: SAVE_IMPORT_EXPORT_WIZARD_SUCCESS
    };
}
